(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'CruiseBookingImportReservation',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function onFormLoad()
	{
		// ended 12/31/18, leaving in case it comes back
		// $('#cruisebookingimportreservation-cruise_line').on('change', function click(e)
		// {
		// 	var $celebrity_block = $('.celebrity-message'),
		// 	    cruise_line_id = $('#cruisebookingimportreservation-cruise_line').val();

		// 	if (cruise_line_id === '3') {
		// 		$celebrity_block.removeClass('hidden');
		// 	} else {
		// 		$celebrity_block.addClass('hidden');
		// 	}
		// });
	};

}(jQuery, window.Adzuki || {}));
